import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useAccordionContext } from "./chunk-JDQBKIKM.mjs";
import { useAccordionItemContext, useAccordionStyles } from "./chunk-JST25EWU.mjs";

// src/accordion-icon.tsx
import { Icon } from "@chakra-ui/icon";
import { cx } from "@chakra-ui/shared-utils";
import { jsx } from "react/jsx-runtime";
function AccordionIcon(props) {
  var _useAccordionItemCont = useAccordionItemContext(),
    isOpen = _useAccordionItemCont.isOpen,
    isDisabled = _useAccordionItemCont.isDisabled;
  var _useAccordionContext = useAccordionContext(),
    reduceMotion = _useAccordionContext.reduceMotion;
  var _className = cx("chakra-accordion__icon", props.className);
  var styles = useAccordionStyles();
  var iconStyles = _objectSpread({
    opacity: isDisabled ? 0.4 : 1,
    transform: isOpen ? "rotate(-180deg)" : void 0,
    transition: reduceMotion ? void 0 : "transform 0.2s",
    transformOrigin: "center"
  }, styles.icon);
  return /* @__PURE__ */jsx(Icon, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    "aria-hidden": true,
    className: _className,
    __css: iconStyles
  }, props), {}, {
    children: /* @__PURE__ */jsx("path", {
      fill: "currentColor",
      d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    })
  }));
}
AccordionIcon.displayName = "AccordionIcon";
export { AccordionIcon };